export enum ResponsiveCalendarBlock {
  Root = 'ResponsiveCalendar',
}
